function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

import is from "./filter-set.js";

var hs = /*#__PURE__*/function () {
  function hs(t, s) {
    _classCallCheck(this, hs);

    this.productId = t, this.tf = s, this.productId = t, this.tf = s;
  }

  _createClass(hs, [{
    key: "zc",
    value: function zc(t) {
      if (null == this.productId || null == this.tf) return !1;
      var s = t[0],
          i = t[1];
      return s === this.productId && this.tf.zc(i);
    }
  }, {
    key: "bt",
    value: function bt() {
      return {
        id: this.productId,
        pf: this.tf ? this.tf.bt() : null
      };
    }
  }], [{
    key: "fromJson",
    value: function fromJson(t) {
      return new hs(t ? t.product_id : null, t ? is.fromJson(t.property_filters) : null);
    }
  }]);

  return hs;
}();

export { hs as default };